import React, {useState, useEffect} from 'react'
import Navbar from '../../Components/Navbar/navbar'
import Smartdetails from '../../Components/Topbar/Smarttask/Smartdetail'
import Smarttask from '../../Components/Topbar/Smarttask/Smarttask'
import Topbarsub from '../../Components/Topbar/Topbarsub'
import SingleTask from './SingleTask/SingleTask'
import TaskList from './SingleTask/taskList'
import './task.css'
// import TaskObjs from './Taskdetails/taskdetailList'
import Taskdetails from './Taskdetails/Taskdetails'

const Task = ({urole, page, addnewoverlay}) => {
    const [onlinePeople, setOnlinePeople] = useState({})
    const [ws, setWs] = useState(null)

    useEffect(() =>{
      const websocket = new WebSocket('ws://localhost:5000')
      setWs(websocket)
      websocket.addEventListener('message', handleMessage)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
  
    const showOnlinepeople = (peopleArray) =>{
      const people = {}
      peopleArray.forEach(({userId, name, email}) => {
        people[userId] = name
      });
      setOnlinePeople(people)
    }
    
    const handleMessage = (e) =>{
      const messageData = JSON.parse(e.data)
      if('online' in messageData){
        showOnlinepeople(messageData.online)
      }
    }

    const [searchcriteria, setSearchcriteria] = useState("all")
    const [itemvalue, setItemvalue] = useState(0)
    // const [arrayresponse, setArrayresponse] = useState(TaskObjs)

    const handleaddOverlay = (incoming) =>{
        addnewoverlay(incoming)
        // console.log(incoming)
    }
  
    useEffect(() => {
        // 👇️ scroll to top on page load
        if(itemvalue > 0){
            LoadData()
        }
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemvalue]);

    const handleTabclick = (incoming) =>{
        setSearchcriteria(incoming.toLowerCase())
    }

    var FilterdTasklist = TaskList.filter((filteredItem) => {
        if (searchcriteria === "all" || searchcriteria === "details" || searchcriteria === "discussion") {
            return filteredItem;
        }
        else{
            return filteredItem.categroy.toLowerCase() === searchcriteria
        }
    });

    const handleClickedIndex = (incoming) =>{
        setItemvalue(incoming)
    }

    const handleBack = () =>{
        setItemvalue(0)
        setSearchcriteria('all')
    }

    const LoadData = () =>{
        // console.log(`Data Loaded ${itemvalue}`)
        
        // Set Arrayed response into this
        // setArrayresponse()
    }

  return (
    <div className='appr-tasks-container'>
        <Navbar tabtext="Smart Task" currentab='others'/>
        <Topbarsub role={urole.role} currrenTab={page} addoverlay={handleaddOverlay}/>

        {itemvalue === 0 ? <div className='main-task-containers'>
            <Smarttask tab={handleTabclick}/>

            <div className='sub-task-containers'>
                {FilterdTasklist.map((item, index)=>(
                    <SingleTask key={index} myref={item.id} body={item} indexclicked={handleClickedIndex} onlinePerson/>))}
            </div>
        </div> : <div className='main-task-containers'>
            <Smartdetails tab={handleTabclick} returntab={handleBack}/>
            
            <Taskdetails clickedid={itemvalue} searchcriteria={searchcriteria} unrole={urole}/>
            
        </div> }
    </div>
  )
}

export default Task